import * as React from "react";

const PdfIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10">
            <path 
                fill="#C63527" 
                fill-rule="evenodd" 
                d="M17.75 1.875V.625h-5v8.75H14v-3.75h3.125v-1.25H14v-2.5h3.75ZM4 .625H.25v8.75H1.5V6.25H4c.69 0 1.25-.56 1.25-1.25V1.875c0-.69-.56-1.25-1.25-1.25ZM4 5H1.5V1.875H4V5Zm5 4.375H6.5V.625H9a2.5 2.5 0 0 1 2.5 2.5v3.75a2.5 2.5 0 0 1-2.5 2.5Zm-1.25-1.25H9c.69 0 1.25-.56 1.25-1.25v-3.75c0-.69-.56-1.25-1.25-1.25H7.75v6.25Z"
            />
        </svg>
    );
};

export default React.memo(PdfIcon);
